import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ContractType } from 'src/app/models/entities/contract-type';
import { Period } from 'src/app/models/entities/period';
import { ContractTypeService } from 'src/app/services/contract-type.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { PeriodService } from 'src/app/services/period.service';

@Component({
  selector: 'app-contract-type-update',
  templateUrl: './contract-type-update.component.html',
  styleUrls: ['./contract-type-update.component.css']
})
export class ContractTypeUpdateComponent implements OnInit {

  destroy$ = new Subject<void>();
  periods$: Observable<Period[]>;
  form: FormGroup;
  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private contractTypeService: ContractTypeService,
    private periodService: PeriodService,
    private userService: NbsUserService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getPeriods();
    this.getContractTypeById();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      contractTypeCode: [""],
      contractTypeName: ["", Validators.required],
      periodId: ["", Validators.required],
      reportTag1: [""],
      reportTag2: [""],
      reportTag3: [""],
      isActive: true
    })
  }

  getContractTypeById() {
    const contractTypeId = parseInt(this.activatedRoute.snapshot.paramMap.get('contractTypeId'));
    this.contractTypeService.getById(contractTypeId).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.form.patchValue(data.data);
    })
  }

  getPeriods() {
    this.periods$ = this.periodService.getList().pipe(map(result => result.data));
  }

  update() {
    if (this.form.valid) {
      const contractType: ContractType = this.form.getRawValue();
      contractType.userId = this.userService.getUserId();
      this.contractTypeService.update(contractType).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
          this.toastrService.success(data.message, "Başarılı");
          this.router.navigateByUrl('/contract-type');
        },
        er => {
          this.toastrService.error(er.error.message, "Hata!");
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

}
